import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'appeals-card',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      maxWidth: theme.spacing(45),
      padding: theme.spacing(3),
      border: `1px solid ${theme.palette.grey[100]}`,
      borderRadius: theme.spacing(1),
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    body: {
      marginBottom: 'auto',
    },
    footer: {},
    date: {},
    link: {
      cursor: 'pointer',
    },
    statusPending: {},
    statusConfirmed: {
      color: theme.palette.success.main,
    },
    statusDeclined: {
      color: theme.palette.error.main,
    },
  }),
  options
);

export default useStyles;
